import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2b88b407075a/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2b88b407075a/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
